import { runDemo } from "../shared/demoRunner";
import { createGltfNormalsScene } from "./scene";

runDemo({
    createScene: createGltfNormalsScene,
});
